module.exports = __webpack_public_path__ + "static/img/logoRH2.015422b.png";


//////////////////
// WEBPACK FOOTER
// ./src/customization/GlobalBPOCore/assets/logoRH2.png
// module id = 19ZZ
// module chunks = 0